import { toast } from "sonner";

export const toastSuccessMessage = (message: string) =>
  toast.success(() => <output role="status">{message}</output>);
